module.exports = __webpack_public_path__ + "static/media/camopanda.b93ff67f.png";